import dayjs from 'dayjs'

const $str = window.$str;

const chartColors = ['#4960FF', '#0CD5FF', '#2DFFAA', '#FFA441', '#944DFF', '#EE3CD3', '#FF532D', '#0DE24A']
const lineColor = "#3e4961"; // 图表splitLine的颜色
const textColor = "#8b93aa"; // 图表文字的颜色

const defaultMin = dayjs().format('YYYY-MM-DD 00:00:00');
const defaultMax = dayjs().format('YYYY-MM-DD 23:59:59');


export function getChartOption(chartData = [], start = defaultMin, end = defaultMax) {
  const { yMin, yMax } = getYaxisRange(chartData);

  const option = {
    color: chartColors,
    grid: [
      {
        top: 40,
        left: 40,
        right: 10,
        bottom: 80
      },
    ],
    xAxis: [
      {
        gridIndex: 0,
        type: 'time',
        min: start,
        max: end,
        name: $str.getKey('数据分析/时间'), // 轴线名称
        nameLocation: 'end',
        nameTextStyle: {
          color: textColor
        },
        axisLabel: {
          color: textColor,
          formatter(value) {
            return dayjs(value).format("YYYY-MM-DD HH:mm:ss").replace(/\s/, '\n'); // 格式化时间格式&折行显示
          },
        },
        axisLine: { // 坐标轴轴线的配置
          lineStyle: {
            color: lineColor
          }
        },
        position: 'bottom', // 轴线展示位置
      },
    ],
    yAxis: [
      {
        gridIndex: 0,
        name: $str.getKey('数据分析/温度(℃)'),
        type: 'value',
        min: yMin,
        max: yMax,
        nameLocation: 'end',
        nameTextStyle: {
          align: 'center',
          color: textColor,
          padding: [0, 0, 0, 35]
        },
        type: 'value',
        splitLine: {
          lineStyle: {
            color: '#eee',
            type: 'dashed'
          }
        },
        axisLabel: {
          color: textColor,
        },
        axisLine: {
          lineStyle: {
            color: lineColor
          }
        },
        splitNumber: 6 // 设置Y轴默认分割5个段
      },
    ],
    series: createSeries(chartData),
    legend: {
      show: false,
      right: 10,
      icon: 'circle',
      itemWidth: 8,
      textStyle: {
        color: textColor
      }
    },
    tooltip: createTooltip(),
    axisPointer: {
      link: { xAxisIndex: 'all' }, // 鼠标指示器-辅助线，对所有坐标系生效
      label: {
        backgroundColor: '#777' // 鼠标指示器-坐标文字提示的颜色
      }
    },
    dataZoom: [
      {
        height: 12,
        bottom: 20,
        textStyle: {
          color: '#8392A5'
        },
        handleIcon: 'path://M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
        dataBackground: {
          areaStyle: {
            color: '#8392A5'
          },
          lineStyle: {
            opacity: 0.8,
            color: '#8392A5'
          }
        },
        brushSelect: true,
        start: 0,
        end: 100,
        xAxisIndex: [0, 1]
      },
      {
        type: 'inside',
        xAxisIndex: [0, 1]
      }
    ]
  }

  return option
}


function getYaxisRange(chartData) {
  const result = {
    yMin: 0,
    yMax: 100,
  }
  if (Array.isArray(chartData) && chartData.length > 0) {
    result.yMin = undefined;
    result.yMax = undefined;
  }

  return result;
}



function createSeries(chartData = []) {
  const series = [];
  if (Array.isArray(chartData) && chartData.length > 0) {
    const lineDataKeys = Object.keys(chartData[0]).filter(key => key.startsWith('t')).sort((a, b) => {
      return Number(a.replace(/[tT]/g, '')) - Number(b.replace(/[tT]/g, ''));
    });

    lineDataKeys.forEach(key => {
      const lineData = chartData.map(item => {
        const time = dayjs(item.record_time).format('YYYY-MM-DD HH:mm:ss');
        const data = Number(item[key]).toFixed(2);
        return [time, data];
      })
      const serieItem = {
        name: key,
        type: 'line',
        symbol: 'none',
        lineStyle: {
          width: 1,
        },
        data: lineData
      }
      series.push(serieItem);
    })
  }

  return series;
}



function createTooltip(config = {}) {
  const timeFormatter = config.timeFormatter || (value => value)
  return {
    show: true,
    trigger: 'axis',
    axisPointer: {
      type: 'cross'
    },
    className: 'chart-tooltip',
    backgroundColor: '#fff',
    // borderWidth: 0,
    borderColor: 'var(--color-black-6)',
    formatter(params) {
      if (params.length > 0) {
        const firstItem = params[0];
        const time = firstItem.axisValueLabel;
        const maxItem = {
          seriesName: firstItem.seriesName,
          value: firstItem.value[1],
          color: firstItem.color,
        }
        const minItem = {
          seriesName: firstItem.seriesName,
          value: firstItem.value[1],
          color: firstItem.color,
        }
        params.forEach(item => {
          if (+item.value[1] > +maxItem.value) {
            maxItem.seriesName = item.seriesName;
            maxItem.value = item.value[1];
            maxItem.color = item.color;
          }
          if (+item.value[1] < +minItem.value) {
            minItem.seriesName = item.seriesName;
            minItem.value = item.value[1];
            minItem.color = item.color;
          }
        })

        return /* html */`
          <div class="chart-tooltip__time">${$str.getKey('数据分析/时间')}: ${time}</div>
          
          <div class="chart-tooltip__items-container">
            <div class="chart-tooltip__series">
              <div class="chart-tooltip__point" style="background: ${maxItem.color}"></div>
              <div class="chart-tooltip__series-name">${$str.getKey('数据分析/最大值')}: </div>
              <div class="chart-tooltip__value">${maxItem.value} ℃</div>
            </div>
            <div class="chart-tooltip__series">
              <div class="chart-tooltip__point" style="background: ${maxItem.color}"></div>
              <div class="chart-tooltip__series-name">${$str.getKey('数据分析/最大值电芯')}: </div>
              <div class="chart-tooltip__value">${maxItem.seriesName}</div>
            </div>

            <hr style="border-color: #ccc"/>

            <div class="chart-tooltip__series">
              <div class="chart-tooltip__point" style="background: ${minItem.color}"></div>
              <div class="chart-tooltip__series-name">${$str.getKey('数据分析/最小值')}: </div>
              <div class="chart-tooltip__value">${minItem.value} ℃</div>
            </div>
            <div class="chart-tooltip__series">
              <div class="chart-tooltip__point" style="background: ${minItem.color}"></div>
              <div class="chart-tooltip__series-name">${$str.getKey('数据分析/最小值电芯')}: </div>
              <div class="chart-tooltip__value">${minItem.seriesName}</div>
            </div>
          </div>  
        `
      }
      return `<div class="chart-tooltip__items-container">${$str.getKey('数据分析/暂无数据')}</div>`
    }
  }
}


